<ng-container *ngIf="isAppReady; else loading">
  <div *ngIf="isLoggedIn; else loginBlock" class="div-container-css">
    <header *ngIf="!isStandaloneRoute()" class="header-box"></header>
    <main-page class="main-box"></main-page>
    <footer *ngIf="!isStandaloneRoute()" class="footer-box"></footer>
  </div>

  <ng-template #loginBlock>
    <app-login></app-login>
  </ng-template>
</ng-container>

<ng-template #loading>
  <div class="app-loader">Loading CMP Application...</div>
</ng-template>
